// extracted by mini-css-extract-plugin
export default {"contact":"Contact_contact__50Cxq","ContactMe":"Contact_ContactMe__dsizM","heading":"Contact_heading__lnAnH"};